import errors from './errors/index.js';
import translation from './translation/index.js';
const de = Object.freeze({
    translation,
    errors,
});
export default de;
